import { ShorUserInterface } from "./users.types";

export interface ReportInterface {
  id: number;
  reporter: ShorUserInterface;
  user: ShorUserInterface;
  post: {
    id: number | null;
    title: string | null;
  };
  /**
   * Present only on comment reports (null for user and post reports).
   * `postId` is the host thread, so the admin can open the comment in
   * context from the reports table.
   */
  comment: {
    id: number;
    body: string;
    postId: number;
    /** True once an admin hid the comment — drives Ascunde vs Afiseaza. */
    isHidden: boolean;
    hiddenAt: string | null;
  } | null;
  // UserReportResource emits these camelCased — the previous snake_case
  // declarations never matched the payload (the table reads them through
  // Antd `dataIndex` strings, so the mismatch stayed invisible).
  hasSpam: boolean;
  hasRacism: boolean;
  hasPorn: boolean;
  hasBadWords: boolean;
  status: ReportsStatuses;
  description: string;
  createdAt: string;
}

export enum ReportsStatuses {
  PENDING = 1,
  RESOLVED = 2
}
